import { Alert, Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { CopyToClipboardButton } from 'src/components/CopyToClipboardButton';
import { useBuilder } from './ContactCaptureBuilderContext';

const InstallCode = ({ installValue }: { installValue: string }) => (
  <Stack spacing={2}>
    <Box>
      <Typography variant="subtitle1" fontWeight={650}>Install on your website</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
        Paste this code before the closing &lt;/body&gt; tag on your site.
      </Typography>
    </Box>
    <Box sx={{ position: 'relative' }}>
      <Box
        component="pre"
        m={0}
        p={2}
        pr={6}
        borderRadius={1}
        bgcolor="grey.100"
        fontSize={13}
        whiteSpace="pre-wrap"
        sx={{ overflowX: 'auto', wordBreak: 'break-word' }}
      >
        {installValue}
      </Box>
      <Box position="absolute" top={8} right={8} bgcolor="background.paper" borderRadius={1}>
        <CopyToClipboardButton
          text={installValue}
          tooltip="Copy installation code"
          ariaLabel="Copy installation code"
        />
      </Box>
    </Box>
  </Stack>
);

export const ContactCaptureInstallTab = () => {
  const { canInstall, installValue, controller } = useBuilder();
  const record = controller.record;

  if (!canInstall) {
    return (
      <Alert severity="info" sx={{ width: '95%' }}>
        Publish this contact capture first. Its installation code will be generated after it has been published.
      </Alert>
    );
  }

  return (
    <Stack spacing={2}>
      <InstallCode installValue={installValue} />
      {record?.status === 'active' ? (
        <Typography variant="body2" color="text.secondary">
          Use Test published widget next to Publish to test the published form and add a real contact.
          For this test page, the allowed website domain must include {window.location.origin}.
          Changes take effect after publishing.
        </Typography>
      ) : (
        <Alert severity="info">Publish or activate this contact capture to collect contacts.</Alert>
      )}
    </Stack>
  );
};
